/**
 * 之前的axios封装有点乱，但是已经在代码中很多地方使用了。
 * 因此在之前request.js进行二次封装，避免影响之前的代码
 */
import axios from 'axios'
import store from '@/store'
import token from '@/utils/token'
import { MessageBox, Message } from 'element-ui'
import { Loading } from 'element-ui'

let loading = null

const whiteList = ['/union-servlet', '/auth/oauth/token']

function startLoading() {
    loading = Loading.service({
        lock: true,
        text: '请稍后',
        background: 'rgba(0, 0, 0, 0.8)'
    })
}

function endLoading() {
    if (loading !== null) {
        loading.close()
    }
    loading = null
}

const requester = axios.create({
    // timeout: 5000, // request timeout
    baseURL: process.env.VUE_APP_BASE_API,
})

// request 拦截器，在请求发出前进行一些处理
requester.interceptors.request.use(
    config => {
        if (config.loading) {
            startLoading()
        }
        // 如果是下载文件的话，增加超时时间
        if (config.responseType === 'blob') {
            config.timeout = 1000 * 60
        } else {
            config.timeout = 1000 * 60
        }
        if (!config.headers.Authorization) {
            let access_token = sessionStorage.getItem("access_token");

            if (access_token || whiteList.indexOf(config.baseURL)) {
                config.headers.Authorization = 'bearer ' + access_token;
                return config
            } else {
                MessageBox.alert('登录失败【token不存在】，请重新登录', { type: 'error' }).then(r => {
                    window.location.href = "/" //表示重新定向到新页面，同时刷新打开的这个页面；
                });
            }
        }
        return config
    },
    error => {
        return Promise.reject(error) //返回一个带有拒绝原因reason参数的Promise对象
    }
)
// response 拦截器，对返回数据进行一些处理
requester.interceptors.response.use(
    response => {
        endLoading()
        if (response.data instanceof Blob) {
            downloadFile(response)
            return;
        }
        let result = response.data;
        if (result.code && result.code != '20000') {
            Message({
                message: result.message || '操作失败',
                type: 'error',
                duration: 5 * 1000
            })
            return Promise.reject(new Error(result.message || '错误'));
        }
        return result;
    },
    error => {//请求错误的处理
        endLoading()
        try {
            if (error.response.status == '401') {
                if (store.state.user.inited) {
                    return MessageBox.alert('未登录或登录过期，请重新登录', { type: 'error' }).then(_ => {
                        window.location.href = "/"
                    }).catch(_ => {
                        window.location.href = "/"
                    })
                }
            }
            if (error.response.status == '500') {
                Message({
                    message: '系统内部错误，请联系管理员。',
                    type: 'error',
                    duration: 5 * 1000
                })
            }
            return Promise.reject(error)
        } catch (e) {
            return Promise.reject(error)
        }
    }
)

function downloadFile(response) {
    const contentDisposition = response.headers['content-disposition'] // 从response的headers中获取filename,后端需要设置允许前端访问此请求头才行
    const patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*")
    const result = patt.exec(contentDisposition)
    const filename = decodeURI(contentDisposition.split('=')[1])
    // const filename = decodeURI(result[1])
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
}
export default requester
